<template>
  <b-table
    :fields="tabela.fields"
    :items="items"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    responsive
    show-empty
    striped
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(acoes)="item">
      <b-dropdown
        variant="outline-default"
        v-if="podeEditar || podeExcluir"
        boundary="window"
      >
        <b-dropdown-item @click="editar(item.item)" v-if="podeEditar">
          {{ $t('GERAL.EDITAR') }}
        </b-dropdown-item>
        <b-dropdown-item @click="excluir(item.item.id)" v-if="podeExcluir">
          {{ $t('GERAL.EXCLUIR') }}
        </b-dropdown-item>
        <b-dropdown-item @click="fechar(item.item)" v-if="podeEditar">
          {{ $t('FINANCEIRO.FINANCEIRO_FECHAMENTO') }}
        </b-dropdown-item>
        <b-dropdown-item @click="reabertura(item.item)" v-if="podeEditar">
          {{ $t('FINANCEIRO.FINANCEIRO_REABRIR') }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </b-table>
</template>
<script>
// Utils & Aux:
import Permissoes from '@/components/mixins/permissoes';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import PeriodoFinanceiroService from '@/common/services/periodo-financeiro/periodo-financeiro.service';

export default {
  mixins: [Permissoes],
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      tabela: {
        fields: [
          {
            key: 'dataMovimento',
            label: 'Data da Movimentação',
            formatter: (value) => {
              return value ? helpers.formatarDataBr(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'dataInicio',
            label: 'Data Início',
            formatter: (value) => {
              return value ? helpers.formatarDataBr(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'dataFim',
            label: 'Data Fim',
            formatter: (value) => {
              return value ? helpers.formatarDataBr(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'saldoAbertura',
            label: 'Saldo Inicial',
            formatter: (value) => {
              return value ? helpers.formatarReal(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'saldoFechamento',
            label: 'Saldo Final',
            formatter: (value) => {
              return value ? helpers.formatarReal(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'statusFinanceiroDescricao',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'acoes',
            label: 'Ações',
          },
        ],
      },
    };
  },
  methods: {
    editar(item) {
      this.$emit('editar', 'editarPeriodoFinanceiro', item);
    },
    fechar(item) {
      this.$emit('fechar', item);
    },
    reabertura(item) {
      this.$emit('reabertura', item);
    },
    excluir(itemId) {
      this.$store.dispatch(START_LOADING);
      PeriodoFinanceiroService.excluir(itemId)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('FINANCEIRO.PERIODO_FINANCEIRO_EXCLUIDO')
          );
        })
        .catch((err) => {
          mensagem.erro(
            this.$t('GERAL.AVISO'),
            err.response.data.errors[0].mensagem
          );
        })
        .finally(() => {
          this.$emit('atualizar-tabela');
          this.$store.dispatch(STOP_LOADING);
        });
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy);
      let ordem = sortDesc;
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
